import { camelizeKeys } from 'humps'
import { useGet, UseGetProps } from 'restful-react'
import { getApiUrl } from 'utils/api/apiHelpers'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { IShipmentLocation } from 'apps/fleet-planner/types'

export interface IGetShipmentLocationsPathParams {
  shipmentId: string
}

export type IUseGetShipmentLocationsProps = Omit<
  UseGetProps<IShipmentLocation, unknown, void, IGetShipmentLocationsPathParams>,
  'path'
> &
  IGetShipmentLocationsPathParams

/**
 * Gets driver location paths and ETA for a given shipment
 */
export const useGetShipmentLocationsData = ({
  shipmentId,
  ...props
}: IUseGetShipmentLocationsProps) => {
  return useGet<IShipmentLocation, unknown, void, IGetShipmentLocationsPathParams>(
    paramsInPath => `${FP_ENDPOINTS.shipments}/${paramsInPath.shipmentId}/locations`,
    /**
     * Override the `base` prop with stark __API__ string
     */
    {
      pathParams: { shipmentId },
      base: getApiUrl('FMS'), // changes base to fp-staging
      resolve: res => (camelizeKeys(res) as unknown) as IShipmentLocation,
      ...props,
    }
  )
}
